import React from "react";
import PropTypes from "prop-types";
import { RichText } from "prismic-reactjs";
import Anchor from "../../../dashboardNew/objects/Anchor";

export const HighlightedArticle = props => {
    const {
        background,
        title,
        description,
        buttons,
        category,
        is_unique
    } = props;

    if (title && title.length > 0 && background)
        return (
            <article className="highlighted-article col-xs-12">
                {background && background.length > 0 && (
                    <img src={background} alt={title} />
                )}

                {// Category
                    category && category.name && (
                        <div className="tag tag--secondary tag--secondary_blue">
                            {category.name}
                        </div>
                    )}

                <div className="highlighted-article__content--portal">
                    {title && <h3 className="h3">{title}</h3>}
                    {is_unique && <h2 className="h2">UNIQUE</h2>}

                    {//IF DESCRIPTION -> render description
                        description &&
                        description.length > 0 &&
                        typeof description !== "string" && (
                            <div className="description">{RichText.render(description)}</div>
                        )}

                    {buttons && (
                        <div className="btn-group">
                            {buttons && buttons[0] && buttons[0].label && buttons[0].url && (
                                <Anchor path={buttons[0].url} anchorClass="simple-link" internal>
                                    {buttons[0].label}
                                </Anchor>
                            )}
                        </div>
                    )}
                </div>
            </article>
        );

    return null;
};

HighlightedArticle.propTypes = {
    background: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    description: PropTypes.arrayOf(PropTypes.object),
    buttons: PropTypes.array,
    category: PropTypes.object,
    is_unique: PropTypes.bool
};



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/HighlightedArticle.js